









import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import ServiceInfo from './ServiceInfo.vue';
import ServicePlans from './ServicePlans.vue';
import ServiceClusters from './ServiceClusters.vue';
import Deployments from '../Deployments/Deployments.vue';

@Component({
  name: 'service',
  components: {
    ServiceInfo,
    ServicePlans,
    ServiceClusters,
    Deployments
  }
})
export default class Service extends Vue {
  @Prop({ required: true, type: String })
  serviceId!: string;

  service!: Service;

  @Getter
  getServiceById!: (id: string) => Service;

  created() {
    this.service = this.getServiceById(this.serviceId);
  }
}
